var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockchainBtnImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8829 22.38L30.6967 26.16",
    stroke: "#EE0033",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6967 13.96L23.8829 17.74",
    stroke: "#EE0033",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6946 10.14V15.4",
    stroke: "#EE0033",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6946 24.72V29.68",
    stroke: "#EE0033",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7176 13.96V10.64L23.9037 6.85997V7.99997L19.6946 10.32L15.4854 7.99997V6.83997L8.67157 10.62V13.96L5.65015 15.64V24.52L8.67157 26.18V29.48L15.4854 33.26V32L19.6946 29.68L23.9037 32V33.22L30.7176 29.46V26.18L33.6765 24.54V15.6L30.7176 13.96Z",
    stroke: "#EE0033",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4854 22.38L8.69241 26.16",
    stroke: "#EE0033",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29648 13.74L15.4854 17.72",
    stroke: "#EE0033",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9037 32.0001L19.6946 29.6801L15.4854 32.0001V36.6801L19.6946 39.0001L23.9037 36.6801V32.0001Z",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9037 32L19.6946 34.34L15.4854 32",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6946 39V34.34",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67157 9.29998L4.48324 6.97998L0.274078 9.29998V13.96L4.48324 16.3L8.67157 13.96V9.29998Z",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67157 9.30005L4.48324 11.64L0.274078 9.30005",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48325 16.3V11.64",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7176 9.29998L34.9059 6.97998L39.1151 9.29998V13.96L34.9059 16.3L30.7176 13.96V9.29998Z",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7176 9.30005L34.9059 11.64L39.1151 9.30005",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9059 16.3V11.64",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67157 26.18L4.48324 23.86L0.274078 26.18V30.84L4.48324 33.18L8.67157 30.84V26.18Z",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67157 26.1801L4.48324 28.5201L0.274078 26.1801",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48325 33.18V28.52",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7176 26.18L34.9059 23.86L39.1151 26.18V30.84L34.9059 33.18L30.7176 30.84V26.18Z",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7176 26.1801L34.9059 28.5201L39.1151 26.1801",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9059 33.18V28.52",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9037 3.34L19.6946 1L15.4854 3.34V8L19.6946 10.32L23.9037 8V3.34Z",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9037 3.33997L19.6946 5.65997L15.4854 3.33997",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6946 10.32V5.66003",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9037 17.74L19.6946 15.4L15.4854 17.74V22.4L19.6946 24.72L23.9037 22.4V17.74Z",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9037 17.74L19.6946 20.06L15.4854 17.74",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6946 24.7201V20.0601",
    stroke: "#225CA6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainBtnImg);
export default __webpack_public_path__ + "static/media/BlockchainBtnImg.9e3745bf420dc4f7359fbaef14e4d6e8.svg";
export { ForwardRef as ReactComponent };